var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30225 16.5117V3.48782C4.30225 3.27194 4.38801 3.0649 4.54066 2.91224C4.69332 2.75959 4.90036 2.67383 5.11624 2.67383H10.1402C10.5719 2.67392 10.9859 2.8455 11.2912 3.15083L15.2211 7.08078C15.5264 7.38602 15.698 7.80003 15.6981 8.23177V16.5117C15.6981 16.7275 15.6123 16.9346 15.4597 17.0872C15.307 17.2399 15.1 17.3257 14.8841 17.3257H5.11624C4.90036 17.3257 4.69332 17.2399 4.54066 17.0872C4.38801 16.9346 4.30225 16.7275 4.30225 16.5117Z",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.67383V7.55778C10 7.77367 10.0858 7.98071 10.2384 8.13336C10.3911 8.28601 10.5981 8.37177 10.814 8.37177H15.6979",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.c5353b590f47f07999c8eed0fdee2577.svg";
export { ForwardRef as ReactComponent };